import React from 'react'
import { useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import { scroller } from 'react-scroll'

import FeatureList from '../Components/FeatureList'

const TopSection = ({ activeType, currentImages, is_auth = false, t }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' })
    const header_height = useSelector(state => state._service.styles.header_height)

    return (
        <div className="mfb-top-section">
            <div className="mfb-top-section__description">
                <div className="mfb-top-section__description-title">
                    <span>{t(activeType.texts.titleTop)}</span>
                    <span>{t(activeType.texts.titleBottom)}</span>
                </div>
                {isMobile ? (
                    <div className="mfb-top-section__image-container">
                        <img src={currentImages.top.coffee} alt="" />
                        <img src={currentImages.top.watches} alt="" />
                    </div>
                ) : null}
                <div className="mfb-top-section__description-text">{t(activeType.texts.description)}</div>
                <div className="mfb-top-section__description-buttons">
                    <button
                        className="button"
                        data-size="lg"
                        data-variant="secondary"
                        onClick={() => {
                            scroller.scrollTo('landing_action_section', {
                                offset: -header_height,
                                smooth: true,
                                duration: 400,
                            })
                        }}
                    >
                        {t(`View live examples`)}
                    </button>
                    <button
                        className="button"
                        data-size="lg"
                        data-variant="primary"
                        onClick={() => {
                            scroller.scrollTo('landing_feedback_section', {
                                offset: -header_height,
                                smooth: true,
                                duration: 400,
                            })
                        }}
                    >
                        {t(`Schedule a demo`)}
                    </button>
                </div>
                <div className="mfb-top-section__description-feature-list">
                    <FeatureList list={activeType.texts.featureList} t={t} />
                </div>
            </div>
            {!isMobile ? (
                <div className="mfb-top-section__image-container">
                    <img src={currentImages.top.coffee} alt="" />
                    <img src={currentImages.top.watches} alt="" />
                </div>
            ) : null}
        </div>
    )
}

export default TopSection
